/**
 * @license
 * James Talmage <james@talmage.io> (github.com/jamestalmage)
 */
export default /^(?:.*[\\/])?node_modules(?:[\\/].*)?$/